import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import {
  ExternalLinkComponent,
  getColumnKey,
  ImageThumbnailComponent,
  ImageThumbnailUnsupportedComponent,
  NoDataComponent,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import { isNotNil } from '@web/utils';
import { AdminBrandBannerCollectionItem } from '../../models/admin-brand-banner-collection-item';
import { AdminBrandBannerCollectionFilter } from '../../models/admin-brand-banner-collection-filter';
import { AdminBrandBannerStatusPipe } from '../../pipes/admin-brand-banner-status.pipe';

@Component({
  selector: 'app-admin-brand-banner-list-custom-cell-template',
  imports: [
    AdminBrandBannerStatusPipe,
    CommonModule,
    ExternalLinkComponent,
    ImageThumbnailComponent,
    ImageThumbnailUnsupportedComponent,
    NgOptimizedImage,
    NoDataComponent,
    TableBodyNoReferenceCellComponent,
  ],
  templateUrl: './admin-brand-banner-list-custom-cell-template.component.html',
  styleUrl: './admin-brand-banner-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminBrandBannerListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<AdminBrandBannerCollectionItem, AdminBrandBannerCollectionFilter>>();
  /* prettier-ignore */
  public readonly model = input.required<AdminBrandBannerCollectionItem>();

  protected readonly getColumnKey =
    getColumnKey<AdminBrandBannerCollectionItem>;
  protected readonly isNotNil = isNotNil;
}
